import React from 'react';
import { FaClock } from 'react-icons/fa';

interface CheckinCheckoutInfoProps {
  checkInTime: string; // Example: '14:00'
  checkOutTime: string; // Example: '12:00'
}

const CheckinCheckoutInfo: React.FC<CheckinCheckoutInfoProps> = ({ checkInTime, checkOutTime }) => {
  return (
    <div className="container p-6 shadow-lg rounded-lg bg-white mx-auto border-t-4 border-halo-pink flex flex-col items-center min-h-[300px]">
  <hr className="w-full mb-4 border-gray-200" />

  <div className="flex items-center justify-center gap-3 mb-4">
    <FaClock className="text-halo-pink w-6 h-6" />
    <h2 className="text-2xl font-semibold text-gray-800">Check-in & Check-out</h2>
  </div>

  <hr className="w-full mb-6 border-gray-200" />

  <div className="space-y-6 w-full max-w-md">
    {/* Check-in */}
    <div>
      <div className="text-sm text-gray-600 font-semibold">Check-in</div>
      <div className="text-sm text-gray-500 mb-1">From <span className="font-medium text-gray-700">{checkInTime}</span></div>
      <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
        <div className="absolute left-0 top-0 h-2 bg-green-500" style={{ width: '50%' }} />
      </div>
      <div className="text-xs text-gray-400 mt-1 text-right">{checkInTime}</div>
    </div>

    {/* Check-out */}
    <div>
      <div className="text-sm text-gray-600 font-semibold">Check-out</div>
      <div className="text-sm text-gray-500 mb-1">Until <span className="font-medium text-gray-700">{checkOutTime}</span></div>
      <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
        <div className="absolute right-0 top-0 h-2 bg-green-500" style={{ width: '50%' }} />
      </div>
      <div className="text-xs text-gray-400 mt-1 text-left">{checkOutTime}</div>
    </div>
  </div>
</div>

  );
};

export default CheckinCheckoutInfo;